import { useState, useEffect } from 'react';

const SIDEBAR_STORAGE_KEY = '@SenhasApp:sidebarOpen';

/**
 * Hook personalizado para gerenciar o estado da sidebar
 * Salva automaticamente o estado no localStorage para persistir entre navegações
 */
const useSidebar = () => {
  // Carrega o estado inicial do localStorage ou define como true se não existir
  const [sidebarOpen, setSidebarOpenState] = useState(() => {
    try {
      const savedState = localStorage.getItem(SIDEBAR_STORAGE_KEY);
      return savedState !== null ? JSON.parse(savedState) : true;
    } catch (error) {
      console.error('Erro ao carregar estado da sidebar do localStorage:', error);
      return true; // Valor padrão em caso de erro
    }
  });

  // Função para alternar o estado da sidebar
  const setSidebarOpen = (newState) => {
    try {
      // Se newState é uma função, executa ela passando o estado atual
      const finalState = typeof newState === 'function' ? newState(sidebarOpen) : newState;
      
      setSidebarOpenState(finalState);
      
      // Salva no localStorage
      localStorage.setItem(SIDEBAR_STORAGE_KEY, JSON.stringify(finalState));
    } catch (error) {
      console.error('Erro ao salvar estado da sidebar no localStorage:', error);
      // Mesmo com erro no localStorage, atualiza o estado local
      setSidebarOpenState(typeof newState === 'function' ? newState(sidebarOpen) : newState);
    }
  };

  // Função para alternar o estado da sidebar (toggle)
  const toggleSidebar = () => {
    setSidebarOpen(prevState => !prevState);
  };

  // Salva o estado no localStorage sempre que mudar (backup adicional)
  useEffect(() => {
    try {
      localStorage.setItem(SIDEBAR_STORAGE_KEY, JSON.stringify(sidebarOpen));
    } catch (error) {
      console.error('Erro ao salvar estado da sidebar no localStorage:', error);
    }
  }, [sidebarOpen]);

  return {
    sidebarOpen,
    setSidebarOpen,
    toggleSidebar
  };
};

export default useSidebar; 